<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Rolling Reserve"
              bc1="App"
              bc2="Rolling Reserve"
              bc3="List"
              path="rolling-reserve"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >

        </div>
      </div>
      <div class="content-body">
                <div class="card">
                  <h5 class="card-header">Search Filter</h5>

                  <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
                    <div class="col-md-6 mb-1 user_plan">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <div class="">
                            <label>Select Store</label>
                            <SearchSelect
                                v-model="selectedStore"
                                url="v1/get-store"
                                :filterParams="{ status: 1 }"
                                :customLabelFn="customStoreNameForMultiselect"
                                placeholder="Search Store..."
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-1 user_plan">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <div class="input-group">
                            <label>Select Terminal</label>
                            <multiselect
                                v-model="selectedTerminal"
                                :options="terminalData"
                                label="label"
                                track-by="id"
                                placeholder="Select Terminal"
                                :loading="terminalLoader"
                                variant="primary"
                                :custom-label="customStoreNameForMultiselect"
                            ></multiselect>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 user_plan">
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <div class="input-group">
                            <label>Select Channel</label>
                            <multiselect
                                v-model="selectedChannel"
                                :options="channelData"
                                label="label"
                                track-by="id"
                                placeholder="Select Channel"
                                :loading="channelLoader"
                                variant="primary"
                                :custom-label="customStoreNameForMultiselect"
                            ></multiselect>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 user_status">
                      <select class="form-control mt-sm-50" style="min-height: 42px"  v-model="recordStatus">
                        <option :value="null">Select Status</option>
                        <option
                            v-for="(item, index) in recordStatusOptions"
                            :key="index"
                            :value="item.id"
                        >{{ item.value }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="container">
                    <div class="divider">or</div>
                  </div>
                  <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
                    <div class="col-md-6 user_status">
                      <input class="form-control"  type="text" v-model="search" placeholder="Search here..."/>
                    </div>
                  </div>
                  <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
                    <div class="col-md-4 user_status">
                      <button type="button" v-show="search == '' || !selectedChannel" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                      <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
                    </div>

                  </div>
                </div>
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="$router.push({ name: 'rolling-reserve-add' })"
                  >
                    <AddButtonText name="Rolling Reserve" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :show-per-page="true"
              :multipleTimeForceApi="multipleTimeForceApi"
              :filteredData="filteredData"

          />
        </div>
      </div>
    </div>
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" :message="`Are You Sure to Change Status to ${status == 2?'Canceled':'Completed'}?`"
                       title="Change Status"
                       @hide="showConfirmationModal = false"></ConfirmationModal>

    <OtherDetailsModal :show="showOtherDetailsModal" :data="othersData"
                                  @hide="showOtherDetailsModal = false"/>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import WithDrawalRequestDetailModal from "@/pages/dashboard/withdrawal-requests/WithDrawalRequestDetailModal.vue";
import OtherDetailsModal from "@/pages/dashboard/rolling-reserve/OtherDetailsModal.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";
import SearchSelect from "@/components/common/SearchSelect.vue";

export default {
  components: {
    SearchSelect,
    AddButtonText,
    OtherDetailsModal,
    WithDrawalRequestDetailModal,
    CommandIcon
  },
  created() {
    this.url = "v1/get-rolling-reserve";
  },
  mounted() {
    localStorage.setItem("url", "v1/get-rolling-reserve");
    this.checkDataInStore('v1/get-rolling-reserve')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    // this.getStoreData()
  },
  data() {
    return {
      recordStatus: null,
      recordStatusOptions: [
        { id: 1, value: "Initiated" },
        { id: 2, value: "Cancelled" },
        { id: 3, value: "Completed" }
      ],
      url: "v1/get-rolling-reserve",
      storageKey: "currency",
      showConfirmationModal:false,
      randomNum:0,
      search: '',
      selectedRow: '',
      status:'',
      multipleTimeForceApi:1,
      tableHeaderValues: [
        {
          title: "UUID",
          valueKey: "uuid"
        },
        {
          title: 'Reference Id',
          valueKey: 'reference_id',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class=" badge text-primary font-small-2">${value}</span>`
            else
              html = `<span class="badge text-dark font-small-2">N/A</span>`

            return  html


          }
        },
        {
          title: "Reserve",
          valueKey: "rolling_reserve",
          html: true,
          alter: function (value) {
            var html = "";
            html = `<div class="badge badge-light-dark">${value + '%'}</div>`;
            return html;
          }
        },
        {
          title: "Account/Channel",
          valueKey: "channel",
          html: true,
          alter: function (value,row) {
            var html = "";
            if(!value) return html

            if(row.user_account)
            html = `<div class="badge badge-light-success mt-1 ">${row.user_account?.account_title}</div>`;

            html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-light-primary mt-1 ">${value.name}/${value.code}</div>
                    </div>
                </div>
                `
            return html;
          }
        },
        {
          title: "Amount",
          valueKey: "amount",
          html: true,
          alter: (value) => {
            if (!value) {
              return "-";
            } else {
              return `<span style="" class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat(
                  value / 100
              ).toFixed(this.amountDecimalPlaces))}</span>`;
            }
          }
        },
        {
          title: "Time Interval",
          valueKey: "time_interval",
          html: true,
          alter: (value) => {
            var html = "";

            const {days, hours, mins} = this.convertDuration(value)

            html = `<div class="badge badge-light-primary">${days + ' days ' + hours + ' hours ' + mins + ' mins'}</div>`;
            return html;
          }
        },
        {
          title: "Created By",
          valueKey: "created_by",
          html: true,
          alter: (value) => {
            var html = `<div class="badge badge-secondary">Auto</div>`;

            if (value)
              html = `<div class="badge badge-secondary">${value.first_name + ' ' + value.last_name + '/' + value.email}</div>`;

            return html;
          }
        },
        {
          title: "Updated By",
          valueKey: "updated_by",
          html: true,
          alter: (value) => {
            var html = `<div class="badge badge-light-dark">Auto</div>`;

            if (value)
              html = `<div class="badge badge-light-dark">${value.first_name + ' ' + value.last_name + '/' + value.email}</div>`;

            return html;
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function (value, row) {
            var html = "";
            if (value == 0) {
              html = `<span class="badge badge-light-warning badge-sm">Pending</span>`;
            } else if (value == 1) {
              html = `<span class="badge badge-light-info badge-sm">Initiated</span>`;
            } else if (value == 2) {
              html = `<span class="badge badge-light-danger badge-sm">Cancelled</span>`;
            } else {
              html = `<span class="badge badge-light-success badge-sm">Complete</span>`;
            }

            return html;
          }
        },
        {
          title: "Created At",
          valueKey: "created_at",
          alter: (value) => {
            // return this.customFormatDateTime(value)
            return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          }
        },
        {
          title: "Updated At",
          valueKey: "updated_at",
          alter: (value) => {
            // return this.customFormatDateTime(value)
            return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          }
        },

      ],
      actions: [
        {
          title: "Complete",
          class: "btn-success",
          conditionalRendering: true,
          disableButtonRendering: true,
          disableCondition: (row) => {
            if (row.status != 1) {
              return true
            }
            return false
          },
          condition: (row) => {
            if (row.status == 1) {
              return true
            }
            return false
          },
          cta: (row, index) => {
            this.selectedRow = row
            this.status = 3
            this.showConfirmationModal = true
          }
        },
        {
          title: "Cancel",
          class: "btn-danger",
          conditionalRendering: true,
          disableButtonRendering: true,
          disableCondition: (row) => {
            if (row.status != 1) {
              return true
            }
            return false
          },
          condition: (row) => {
            if (row.status == 1) {
              return true
            }
            return false
          },
          cta: (row, index) => {
            this.selectedRow = row
            this.status = 2
            this.showConfirmationModal = true
          }
        },
        {
          title: "Other Info",
          class: "btn-warning badge mr-1",
          cta: (row, index) => {
            this.othersData = row
            this.showOtherDetailsModal = true
          }
        }
      ],
      othersData:[],
      showOtherDetailsModal:false,
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader: false,
      channelLoader: false,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      filteredData: {},
    };
  },
  methods: {
    customStoreNameForMultiselect({name, code}) {
      return `${name}/${code}`
    },
    onSubmitFilters() {

      let filterData = {}

      // if(this.selectedStore){
      //   filterData.storeId = this.selectedStore.id
      // }
      // if(this.selectedTerminal){
      //   filterData.terminalId = this.selectedTerminal.id
      // }

      if (this.selectedChannel) {
        filterData.channelId = this.selectedChannel.id
      }

      if (this.recordStatus) {
        filterData.status = this.recordStatus
      }

      if (this.search != '') {
        filterData.search = this.search
      }

      this.filteredData = filterData

    },
    clear() {
      this.search = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {}
    },
    getStoreData() {
      this.makeRequest("post", "v1/get-store", {status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.storeData = responseData;
                }
                else{
                  this.storeData = []
                }
                // this.setSelectedStoreValue();
              }
            }
          }
      );
    },
    setSelectedStoreValue() {


      if (this.selectedStore == null && this.storeData.length > 0) {
        this.selectedStore = this.storeData[0];

      }
      else{
        this.selectedStore = null
      }
    },
    getTerminalData() {
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
                // this.setSelectedTerminalValue();
              }
            }
            this.terminalLoader = false
          }
      );
    },
    setSelectedTerminalValue() {


      if (this.selectedTerminal == null && this.terminalData.length > 0) {
        this.selectedTerminal = this.terminalData[0];

      }
      else{
        this.selectedTerminal = null
      }
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                // this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    confirm() {
      let row = this.selectedRow
      this.showConfirmationModal = false
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/update-rolling-reserve-status", {
        rollingReserveId: row.id,
        status: this.status,
      }).then(callResponse => {
        this.$store.dispatch('exportExcelLoader', false)
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.multipleTimeForceApi = this.multipleTimeForceApi + 1
          }
        }


      });
    }
  },
  watch: {
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      this.getTerminalData()
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
  }
};
</script>

